<template>
  <div class="printing-signature-root">
    <div>
      <field
        :label="title"
        type="h3"
      ></field>

      <img
        v-if="signature"
        :src="`data:image/png;base64, ${signature}`"
        alt="Court president signature"
        width="100"
      >
    </div>
  </div>
</template>

<script>
import Field from '@/components/printing/field.vue';

export default {
  components: { Field },
  props: {
    title: {
      type: String,
      default: '',
    },
    signature: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.printing-signature-root {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  margin-bottom: 80px;
  text-align: center;
}
</style>
